<div class="c-content c-content--wrapper u-no-p" [ngStyle]="vm.loading && {'min-height': '300px'}">
	<div *ngIf="!vm.loading">
		<div class="c-content c-content--border-bottom u-no-ph@md-and-up u-hidden@up-to-md">
			<div class="o-grid o-grid--wrap">
				<div class="o-grid__cell o-grid__cell--w-15 u-no-p">
					<a href="javascript:void(0)" class="c-text c-text--gray" (click)="vm.setFilter('validFrom')" aria-hidden="true">
						<span style="vertical-align:middle">{{ 'Insurance.Policy.Valid_From' | translate }}</span>&nbsp;
						<span *ngIf="vm.filter.orderBy==='validFrom' && vm.filter.ascending">&#8595;</span>
						<span *ngIf="vm.filter.orderBy==='validFrom' && !vm.filter.ascending">&#8593;</span>
					</a>
				</div>
				<div class="o-grid__cell o-grid__cell--w-15 u-no-p">
					<a href="javascript:void(0)" class="c-text c-text--gray" (click)="vm.setFilter('validTo')" aria-hidden="true">
						<span style="vertical-align:middle">{{ 'Insurance.Policy.Valid_To' | translate }}</span>&nbsp;
						<span *ngIf="vm.filter.orderBy==='validTo' && vm.filter.ascending">&#8595;</span>
						<span *ngIf="vm.filter.orderBy==='validTo' && !vm.filter.ascending">&#8593;</span>
					</a>
				</div>
				<div class="o-grid__cell o-grid__cell--w-25 u-no-p">
					<a href="javascript:void(0)" class="c-text c-text--gray" (click)="vm.setFilter('policyNumber')" aria-hidden="true">
						<span style="vertical-align:middle">{{ 'Insurance.Policy.Policy_Number' | translate }} ({{ 'Insurance.Policy.Insurer_Name' | translate }})</span>&nbsp;
						<span *ngIf="vm.filter.orderBy==='policyNumber' && vm.filter.ascending">&#8595;</span>
						<span *ngIf="vm.filter.orderBy==='policyNumber' && !vm.filter.ascending">&#8593;</span>
					</a>
				</div>
				<div class="o-grid__cell o-grid__cell--w-15 u-no-p">
					<a href="javascript:void(0)" class="c-text c-text--gray" (click)="vm.setFilter('packageName')" aria-hidden="true">
						<span style="vertical-align:middle">{{ 'Insurance.Policy.Package_Name' | translate }}</span>&nbsp;
						<span *ngIf="vm.filter.orderBy==='packageName' && vm.filter.ascending">&#8595;</span>
						<span *ngIf="vm.filter.orderBy==='packageName' && !vm.filter.ascending">&#8593;</span>
					</a>
				</div>
				<div class="o-grid__cell o-grid__cell--w-10 u-no-p">
					<a href="javascript:void(0)" class="c-text c-text--gray c-text--right" (click)="vm.setFilter('status')" aria-hidden="true">
						<span style="vertical-align:middle">{{ 'Insurance.Policy.Status' | translate }}</span>&nbsp;
						<span *ngIf="vm.filter.orderBy==='status' && vm.filter.ascending">&#8595;</span>
						<span *ngIf="vm.filter.orderBy==='status' && !vm.filter.ascending">&#8593;</span>
					</a>
				</div>
				<div class="o-grid__cell o-grid__cell--w-20 u-no-p">
					<span></span>
				</div>
			</div>
		</div>
		<ul class="c-list">
			<li *ngFor="let insurancePolicy of vm.insurancePolicies | startFrom:vm.currentPage*vm.pageSize | arrayLimitTo:vm.pageSize ; let $parentIndex=index">
				<div class="c-panel u-no-p" panel [isOpen]="insurancePolicy._isOpen">
					<div class="c-content c-content--border-bottom u-no-ph@md-and-up">
						<div class="o-grid o-grid--wrap@up-to-md">
							<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-15@md-and-up u-no-p">
								<div class="o-grid o-grid--center-v u-hidden@md-and-up">
									<div class="o-grid__cell u-no-p">
										<p class="c-text c-text--sm c-text--gray u-hidden@md-and-up">{{ 'Insurance.Policy.Valid_From' | translate }}:</p>
									</div>
									<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p">
										<p class="c-text c-text--sm@up-to-md">
											{{ insurancePolicy.validFrom | date:'dd.MM.yyyy' }}
										</p>
									</div>
								</div>
								<p class="c-text c-text--s10 u-hidden@up-to-md">
									{{ insurancePolicy.validFrom | date:'dd.MM.yyyy' }}
								</p>
							</div>
							<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-15@md-and-up u-no-p">
								<div class="o-grid o-grid--center-v u-hidden@md-and-up">
									<div class="o-grid__cell u-no-p">
										<p class="c-text c-text--sm c-text--gray u-hidden@md-and-up">{{ 'Insurance.Policy.Valid_To' | translate }}:</p>
									</div>
									<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p">
										<p class="c-text c-text--sm@up-to-md">
											{{ insurancePolicy.validTo | date:'dd.MM.yyyy' }}
										</p>
									</div>
								</div>
								<p class="c-text c-text--s10 u-hidden@up-to-md">
									{{ insurancePolicy.validTo | date:'dd.MM.yyyy' }}
								</p>
							</div>
							<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-25@md-and-up u-no-p">
								<div class="o-grid o-grid--center-v u-hidden@md-and-up">
									<div class="o-grid__cell u-no-p">
										<p class="c-text c-text--sm c-text--gray u-hidden@md-and-up">{{ 'Insurance.Policy.Policy_Number' | translate }}:</p>
									</div>
									<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p">
										<p id="policyNumberTextOnlyLabel1_{{$parentIndex}}" *ngIf="!insurancePolicy.externalPolicyDownloadUrl" class="c-text c-text--sm@up-to-md">
											{{ insurancePolicy.policyNumber }} {{ vm.getInsurerName(insurancePolicy) }}
										</p>
										<a id="policyNumberLink1_{{$parentIndex}}" *ngIf="insurancePolicy.externalPolicyDownloadUrl" href="{{ insurancePolicy.externalPolicyDownloadUrl }}" target="_blank" rel="noopener" class="c-text c-text--sm@up-to-md">
											{{ insurancePolicy.policyNumber }} {{ vm.getInsurerName(insurancePolicy) }}
										</a>
									</div>
								</div>
								<p id="policyNumberTextOnlyLabel2_{{$parentIndex}}" *ngIf="!insurancePolicy.externalPolicyDownloadUrl" class="c-text c-text--s10 u-hidden@up-to-md">
									{{ insurancePolicy.policyNumber }} {{ vm.getInsurerName(insurancePolicy) }}
								</p>
								<a id="policyNumberLink2_{{$parentIndex}}" *ngIf="insurancePolicy.externalPolicyDownloadUrl" href="{{ insurancePolicy.externalPolicyDownloadUrl }}" target="_blank" rel="noopener" class="c-text u-hidden@up-to-md">
									{{ insurancePolicy.policyNumber }} {{ vm.getInsurerName(insurancePolicy) }}
								</a>
							</div>
							<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-15@md-and-up u-no-p">
								<div class="o-grid o-grid--center-v u-hidden@md-and-up">
									<div class="o-grid__cell u-no-p">
										<p class="c-text c-text--sm c-text--gray u-hidden@md-and-up">{{ 'Insurance.Policy.Package_Name' | translate }}:</p>
									</div>
									<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p">
										<p id="insurancePackageDisplayName1_{{$parentIndex}}" class="c-text c-text--sm@up-to-md">
											{{ insurancePolicy.purchasedPackage.displayName }}
										</p>
									</div>
								</div>
								<p id="insurancePackageDisplayName2_{{$parentIndex}}" class="c-text c-text--s10 u-hidden@up-to-md">
									{{ insurancePolicy.purchasedPackage.displayName }}
								</p>
							</div>
							<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-10@md-and-up u-no-p">
								<div class="o-grid o-grid--center-v u-hidden@md-and-up">
									<div class="o-grid__cell u-no-p">
										<p class="c-text c-text--sm c-text--gray u-hidden@md-and-up">{{ 'Insurance.Policy.Status' | translate }}:</p>
									</div>
									<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p">
										<p id="insuranceStatus1_{{$parentIndex}}" class="c-text c-text--sm@up-to-md">{{ 'Insurance.Policy.Status_' + (insurancePolicy.policyUserStatus ? insurancePolicy.policyUserStatus : insurancePolicy.status) | translate }}</p>
									</div>
								</div>
								<p id="insuranceStatus2_{{$parentIndex}}" class="c-text c-text--s10 u-hidden@up-to-md">{{ 'Insurance.Policy.Status_' + (insurancePolicy.policyUserStatus ? insurancePolicy.policyUserStatus : insurancePolicy.status) | translate }}</p>
							</div>
							<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-20@md-and-up u-no-p u-ost-md@up-to-md">
								<div style="text-align: right">
									<div id="toggleCoverDetails_{{$parentIndex}}" class="c-panel__header c-panel__header--sm"
										 (click)="vm.getCovers(insurancePolicy)"
										 style="display: inline-block">
										<a href="javascript:void(0)" type="button" class="c-text c-text--uppercase c-text--bold">
											{{insurancePolicy._isOpen ? ('Consents.Table.Close' | translate) : ('Consents.Table.View' | translate)}}
										</a>
									</div>
									&nbsp;
									<div id="editPolicyButton_{{$parentIndex}}" *ngIf="insurancePolicy.policyUserStatus === 'ACTIVE' && !insurancePolicy.purchasedPackage.forPrivateCustomer && vm.canEditPolicy(insurancePolicy)"
										 (click)="vm.editPolicy(insurancePolicy)"
										 style="display: inline-block">
										<a href="javascript:void(0)" type="button" class="c-text c-text--uppercase c-text--bold">{{'Modal.Title.Edit' | translate}}</a>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="c-panel__content c-panel__content--bg u-no-ph@md-and-up">
						<div class="c-content">
							<div class="o-grid">
								<div class="o-grid__cell o-grid__cell--w-100 u-no-p">
									<div style="padding-bottom:20px;" *ngIf="insurancePolicy && insurancePolicy.insuranceContact">
										<item-notification icon="attention" [text]="vm.getContactUsInfo(insurancePolicy)" [theme]="5"></item-notification>
									</div>
									<div *ngIf="insurancePolicy.covers">
										<ul class="c-list">
											<li *ngFor="let cover of insurancePolicy.covers ; let $index=index ; let $last = last">
												<div class="c-content u-no-ph@md-and-up" [ngClass]="{'c-content--border-bottom': (cover.bottomBorder && !$last)}">
													<div style="padding-bottom:20px;" *ngIf="cover.invoiceNeededByEmployer">
														<item-notification icon="attention" [text]="vm.getInvoiceNeededByEmployerInfo()" [theme]="5"></item-notification>
													</div>
													<div style="padding-bottom:20px;" *ngIf="cover.preAuthorizationRequired">
														<item-notification icon="attention" [text]="vm.getPreAuthorizationRequiredInfo(cover)" [theme]="5"></item-notification>
													</div>
													<div class="o-grid o-grid--wrap@up-to-md">
														<div class="o-grid__cell o-grid__cell--w-60 u-no-p">
															<p id="coverParentTitle_{{$parentIndex}}-{{$index}}" *ngIf="cover.title && !cover.parent" style="white-space:pre-line;" class="c-text c-text--sm@up-to-md c-text--bold u-osr-xl">{{ vm.getCoverTitle(cover) }}</p>
															<p id="coverChildTitle_{{$parentIndex}}-{{$index}}" *ngIf="cover.title && cover.parent" style="white-space:pre-line;" class="c-text c-text--sm@up-to-md u-osr-xl"> - {{ vm.getCoverTitle(cover) }}</p>
															<p id="coverDescription_{{$parentIndex}}-{{$index}}" *ngIf="cover.description" style="white-space:pre-line;" class="c-text c-text--sm u-hidden@up-to-md u-osr-xl">{{ vm.getCoverDescription(cover) }}</p>
														</div>
														<div class="o-grid__cell o-grid__cell--w-40 u-no-p" *ngIf="cover.limitGroupingParent">
															<p *ngIf="vm.getCoverExtra(cover)" class="c-text c-text--sm@up-to-md" style="text-align:center;">
																<span style="white-space:pre-line;">{{ vm.getCoverExtra(cover) }}</span>
															</p>
															<p *ngIf="vm.getCoverLimit(cover)" class="c-text c-text--sm@up-to-md" style="text-align:center;">
																<span *ngIf="!cover.exclusion && !cover.inclusion">{{ 'Insurance.Policy.Limits' | translate }}</span>
																<span id="coverLimitLabel_{{$parentIndex}}-{{$index}}">{{ vm.getCoverLimit(cover) }}</span>
															</p>
															<p class="c-text c-text--sm@up-to-md" style="text-align:center;" *ngIf="!cover.exclusion && vm.getCoverDeductible(cover)">
																<span>{{ 'Insurance.Policy.Deductible' | translate }}</span>
																<span id="coverDeductible_{{$parentIndex}}-{{$index}}">{{ vm.getCoverDeductible(cover) }}</span>
															</p>
															<p class="c-text c-text--sm@up-to-md" style="text-align:center;" *ngIf="!cover.exclusion && vm.getCoverCoverageRate(cover)">
																<span>{{ 'Insurance.Policy.CoverageRate' | translate }}</span>
																<span id="coverCoverageRate_{{$parentIndex}}-{{$index}}">{{ vm.getCoverCoverageRate(cover) }}</span>
															</p>
															<p class="c-text c-text--sm@up-to-md" style="text-align:center;" *ngIf="cover.moreInfoUrl">
																<a id="coverMoreInfoLink_{{$parentIndex}}-{{$index}}" href="{{ cover.moreInfoUrl }}" target="_blank">{{ 'Insurance.Policy.ReadMore' | translate }}</a>
															</p>
														</div>
													</div>
												</div>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</li>
		</ul>
		<item-no-content *ngIf="!vm.insurancePolicies?.length"></item-no-content>
	</div>
	<loader-overlay *ngIf="vm.loading"></loader-overlay>
</div>
